import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  models: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createNewModel: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateModel: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteModel: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  repText: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteRepText: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  regions: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  searchValue: "",
  sortBy: "",
  selectedPage: 0,
  isTouched: false,
  showSidePanel: false,
};

export const modelReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.SET_SHOW_SIDE_PANEL:
    return{
      ...newState,
      showSidePanel: action.payload
    }
    case actionTypes.SELECTED_MODEL_PAGE:
    return{
      ...newState,
      selectedPage: action.payload
    }

    case actionTypes.GET_MODELS:
      return {
        ...newState,
        models: { ...newState.models, isLoading: true, hasError: false },
      };
    case actionTypes.GET_MODELS_SUCCESS:
      return {
        ...newState,
        models: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_MODELS_FAILURE:
      return {
        ...newState,
        models: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.GET_REPTEXT:
      return {
        ...newState,
        repText: { ...newState.repText, isLoading: true, hasError: false },
      };
    case actionTypes.GET_REPTEXT_SUCCESS:
      return {
        ...newState,
        repText: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_REPTEXT_FAILURE:
      return {
        ...newState,
        repText: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.CREATE_NEW_MODEL:
      return {
        ...newState,
        createNewModel: { ...newState.createNewModel, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_MODEL_SUCCESS:
      return {
        ...newState,
        createNewModel: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_MODEL_FAILURE:
      return {
        ...newState,
        createNewModel: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.UPDATE_REPTEXT:
      return {
        ...newState,
        updateRepText: { ...newState.updateRepText, isLoading: true, hasError: false },
      };
    case actionTypes.UPDATE_REPTEXT_SUCCESS:
      return {
        ...newState,
        updateRepText: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.UPDATE_REPTEXT_FAILURE:
      return {
        ...newState,
        updateRepText: { data: action.payload, isLoading: false, hasError: true },
      };

      case actionTypes.GET_REGIONS:
      return {
        ...newState,
        regions: { ...newState.regions, isLoading: true, hasError: false },
      };
    case actionTypes.GET_REGIONS_SUCCESS:
      return {
        ...newState,
        regions: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_REGIONS_FAILURE:
      return {
        ...newState,
        regions: { data: action.payload, isLoading: false, hasError: true },
      };

    default:
      return { ...newState };
  }
};
